



























































import { defineComponent } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import FormatMoney from "@/components/FormatMoney";
import StatementItemDetailsTableItem from "./StatementItemDetailsTableItem.vue";
import { EarningReportData, EarningReportTypeStatDetails, StatField } from "../../types";
import StatementChartController from "../StatementChartController";

export default defineComponent({
  name: "StatementItemDetails",
  components: { FormatMoney, StatementItemDetailsTableItem, StatementChartController },
  props: {
    report: { type: Object as () => EarningReportData, required: true },
    fields: { type: Array as () => StatField[], required: true },
    totalDetails: { type: Object as () => EarningReportTypeStatDetails, required: true },
  },
  setup() {
    const { isTalentAgent } = useAuthUser();
    return { isTalentAgent };
  },
});
